module.exports = __webpack_public_path__ + "prj_08.369d62de.jpeg";